<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MlbbSeriesGameWaiting',
  props: {
    gameNumber: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true,
      validator: (v) => v === 'waiting' || v === 'not_needed'
    },
    hostScore: {
      type: Number,
      default: 0
    },
    guestScore: {
      type: Number,
      default: 0
    },
    hostTeamName: {
      type: String,
      default: ''
    },
    guestTeamName: {
      type: String,
      default: ''
    },
    targetWins: {
      type: Number,
      default: 2
    }
  },
  computed: {
    winnerName() {
      return this.hostScore > this.guestScore ? this.hostTeamName : this.guestTeamName
    }
  }
})
</script>

<template>
  <div class="series-waiting">
    <div class="series-waiting__icon">
      <span v-if="status === 'waiting'" aria-hidden="true">⏱</span>
      <span v-else aria-hidden="true">⊘</span>
    </div>
    <template v-if="status === 'waiting'">
      <p class="series-waiting__title">Игра {{ gameNumber }} ещё не началась</p>
      <p class="series-waiting__desc">
        Дождитесь окончания текущей игры. Игра {{ gameNumber }} откроется автоматически.
      </p>
    </template>
    <template v-else>
      <p class="series-waiting__title">Игра {{ gameNumber }} не потребовалась</p>
      <p class="series-waiting__desc">
        {{ winnerName }} уже одержала необходимые {{ targetWins }} победы. Матч серии завершён досрочно со счётом {{ hostScore }}:{{ guestScore }}.
      </p>
    </template>
  </div>
</template>

<style scoped lang="scss">
.series-waiting {
  background: #fff;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  margin-bottom: 20px;

  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #f1f2f6;
    color: #6b6f7c;
    font-size: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  &__title {
    margin: 0;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #495057;
  }

  &__desc {
    margin: 8px auto 0;
    max-width: 460px;
    font-size: 13px;
    color: #6b6f7c;
    line-height: 1.5;
  }
}
</style>
